import { render, staticRenderFns } from "./ResponseQuestion.vue?vue&type=template&id=6e22eb3d&"
import script from "./ResponseQuestion.vue?vue&type=script&lang=js&"
export * from "./ResponseQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports